import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    maxHeight: 260,
    position: "relative",
    "& $swipeContainer:hover + #fullscreenIcon": {
      display: "block",
    },
  },
  fullscreenIcon: {
    background: theme.hv.palette.base.base2,
    position: "absolute",
    zIndex: 1,
    right: theme.hv.spacing.xs,
    top: theme.hv.spacing.xs,
    display: "none",
    borderRadius: 3,
    cursor: "pointer",
    "&:hover": {
      display: "block",
      background: `${theme.hv.palette.base.base2}!important`,
      "& path": {
        fill: `${theme.hv.palette.atmosphere.atmo1}!important`,
      },
    },
    "& path": {
      fill: `${theme.hv.palette.atmosphere.atmo4}!important`,
    },
  },
  fullscreen: {},
  fullscreenContent: {
    marginTop: 0,
    maxWidth: "100vh",
    maxHeight: "100vh",
    "& img": {
      maxHeight: "100vh",
    },
  },
  fullscreenStepper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    background: "none",
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 32,
    paddingRight: 32,
    position: "absolute",
    bottom: 0,
    width: "100%",
    backgroundColor: "rgba(0,0,0,0.4)",
  },
  fullscreenStepperCount: {
    color: theme.hv.palette.atmosphere.atmo4,
    marginLeft: theme.hv.spacing.md,
    marginRight: theme.hv.spacing.md,
    "&::first-letter": {
      fontWeight: 600,
    },
  },
  fullscreenButton: {
    "& path": {
      fill: `${theme.hv.palette.atmosphere.atmo3}!important`,
    },
    "&:hover": {
      cursor: "pointer",
      background: "transparent",
      "& path": {
        fill: `${theme.hv.palette.atmosphere.atmo1}!important`,
      },
    },
  },
  button: {
    "& path": {
      fill: `${theme.hv.palette.accent.acce1}!important`,
    },
    "&:hover": {
      cursor: "pointer",
      background: "transparent",
      "& path": {
        fill: `${theme.hv.palette.atmosphere.atmo5}!important`,
      },
    },
    "&$fullscreenIcon": {},
  },
  unavailableIcon: {
    marginBottom: theme.hv.spacing.sm,
    "&.fullscreen": {
      "& path": {
        fill: `${theme.hv.palette.atmosphere.atmo1}!important`,
      },
    },
  },
  selected: {
    "& path": {
      fill: `${theme.hv.palette.atmosphere.atmo1}!important`,
    },
  },
  loadingContainer: {
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
  },
  loading: {
    marginLeft: theme.hv.spacing.xs,
    color: theme.hv.palette.atmosphere.atmo3,
  },
  step: {
    height: 200,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  fullscreenStep: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  swipeContainer: {
    height: 200,
  },
  fullscreenSwipeContainer: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  stepper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    background: "none",
    paddingTop: 10,
    maxHeight: 250,
  },
  stepperCount: {
    color: theme.hv.palette.accent.acce1,
    "&::first-letter": {
      fontWeight: 600,
    },
  },
  content: {
    maxHeight: 200,
  },
  controls: {
    position: "absolute",
    display: "flex",
    bottom: theme.hv.spacing.xs,
    right: theme.hv.spacing.xs,
  },
  sideButton: {
    width: 50,
    height: 200,
    position: "absolute",
    top: "calc(50vh - 100px)",
    "&:hover": {
      cursor: "pointer",
    },
  },
  sideBackButton: {
    left: 0,
  },
  sideNextButton: {
    right: 0,
  },
  unavailable: {
    marginBottom: theme.hv.spacing.sm,
    "&.fullscreen": {
      color: theme.hv.palette.atmosphere.atmo3,
    },
  },
  unavailableContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "&.fullscreen": {
      width: "100vh",
      textAlign: "center",
    },
  },
}));

export default useStyles;
